const common = {
  "members.label.member": "Miembro",
  "members.label.members": "Miembros",
};

const membersPage = {
  "members.table.header.member": "Miembro",
  "members.table.header.byb-iq": "BYB IQ",
  "members.table.see-progress": "Ver progreso",
  "members.table.no-data": "No hay datos de miembros disponibles",
  "members.table.manage-columns": "Gestionar columnas",
  "members.download-report": "Descargar informe",
  "members.invite.remaining-seats": "{{ count }} restantes",
  "members.filters.search": "Buscar miembros...",
  "members.filters.status": "Estado",
  "members.filters.role": "Rol",
  "members.filters.roles": "Roles",
  "members.filters.all": "Todos",
  "members.filters.all-roles": "Todos los roles",
  "members.filters.results": "{{ count }} resultados",
  "members.filters.default-sort": "Orden predeterminado",
  "members.filters.sort-name": "Nombre",
  "members.filters.sort-role": "Rol",
  "members.filters.default-filter": "Filtro predeterminado",
  "members.filters.filtered": "Filtrado",
  "members.filters.clear-filters": "Limpiar filtros",

  "members.member.delete-confirmation.title": "Eliminar miembro",
  "members.member.delete-confirmation.message": "¿Estás seguro de que deseas eliminar a este miembro?",
  "members.pending.delete-confirmation.title": "Eliminar invitación",
  "members.pending.delete-confirmation.message": "¿Estás seguro de que deseas eliminar esta invitación?",
};

const memberProfile = {
  "members.profile.delete-member": "Eliminar miembro",
};

export const members = {
  ...common,
  ...membersPage,
  ...memberProfile,
};
